import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as WarningIcon } from 'theme/assets/images/warning.svg';
import './EntryClosedOverlay.scss';

export interface IEntryClosedOverlay {
  show: boolean;
}

const EntryClosedOverlay = (props: IEntryClosedOverlay) => {
  const [show, setShow] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timeout = setTimeout(() => setShow(props.show), 250);
    return () => clearTimeout(timeout);
  }, [props.show]);

  return (
    <div className={`entry-closed-overlay entry-closed-overlay--${show ? 'active' : 'inactive'}`}>
      <div className="entry-closed-overlay__dialog">
        <WarningIcon className="entry-closed-overlay__icon" data-testid="warning-icon" />
        <span className="entry-closed-overlay__message">{t('entry-closed')}</span>
      </div>
    </div>
  );
};

export default EntryClosedOverlay;
